/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useClient from "./useInspectionClient";
import { trackPromise } from "react-promise-tracker";

export const useData = <T,>(endpoint: string): T | undefined => {
  const client = useClient();
  const [data, setData] = useState<T>();

  useEffect(() => {
    const getData = async () => {
      try {
          const response = await client.api(endpoint).get();
         // console.log("get call");
        setData(response.data as T);
      } catch (error: any) {
        toast.error(error);
      }
    };

    if (!data) trackPromise(getData());
  }, []);

  return data;
};

export default useData;
